/*
 * 選択コンボ
 */
<template>
<div :class="this.main_class" :id="createCustomeId(m_inputPrefix)">
	<div v-if="r_label != undefined && r_label.length > 0" class="name">
		{{r_label}}
	</div>
	<span :class="this.sub_class">
		<el-select 
			class="list-select"
			:class="select_class" 
			v-model="m_nSelect"
			:disabled="is_readonly"
			@blur="onBlur"
			:placeholder="r_placeholder"
			@change="onChange">
			<el-option
				v-for="item in m_arrList"
				:key="item.value"
				:label="item.label"
				:value="item.value"
				:disabled="item.disabled" >
			</el-option>
		</el-select>
	</span>
	<div class="left disp-message error-messages" v-if="r_is_disp_err && err_msg.length > 0">
		{{err_msg}}
	</div>
</div>
</template>
<script>
//import emitter from 'element-ui/src/mixins/emitter';
import emitter from 'js/common/emitter';
//import Migrating from 'element-ui/src/mixins/migrating';
import Migrating from 'js/common/migrating';
	 export default {
		mixins: [
			emitter,
			Migrating,
			// マネージャーインスタンスアクセス
			require('js/common/vuex/manager/read.mixin.vue'),
		],
		props:{
			'value':{},
			'r_label':{},
			'r_list':{},
			'r_select_class':String,
			'r_name_main_class':String,
			'r_name_sub_class':String,
			'r_id':{},
			'r_readonly':false,
			'r_disabled':false,
			'r_placeholder':{
				type:String,
				default:""
			},
			'r_not_match_list_text':{
				trye:String,
				default:""
			},
			'validateEvent': {
				type: Boolean,
				default: true
			},
			'r_is_disp_err':{
				default:false,
			},
		},
		data: function (){
			return{
				m_nSelect:'',
				m_strID:'',
				m_strErr:"",
				m_arrList:{},
				m_inputPrefix:'input-',
				m_inputSuffix:'',
			}
		},
		created: function(){
		},
		mounted: function(){
			this.createList();
			this.m_nSelect = this.checkMatchList();
			this.m_strID = this.createUUID();
			// IEの場合初期表示が更新されないため、jQuery で明示的に更新をかける
/*			var target = this;
			setTimeout(function(){
				target.m_nSelect = target.value+'';
				$("#" + target.m_strID).val(target.m_nSelect);
			},100);
*/			//console.log("[ SelectItem Mounted ]" + this.value);
		},
		/**
		 * computed
		 * @prop {object} disp_lists - List取得
		 * @instance
		 **/
		computed: {
			select_class:function(){

				return this.r_select_class;
			},
			msg_err:function(){
				if(this.r_messages){
					return this.r_messages;
				}
				return this.manager.r_messages;
			},
			is_readonly: function(){
				if(this.r_readonly || this.r_disabled)return true;
				return false;
			},
			main_class : function(){
				if(this.r_name_main_class === undefined ){
					return "select-component";
				}
				return this.r_name_main_class;
			},
			sub_class : function(){
				var add ="readwrite";
				if(this.r_readonly){
					add = "readonly";
				}
				if(this.r_disabled){
					add += "-disabled ";
				}else{
					add += "-enabled ";
				}

				if(this.r_name_sub_class === undefined ){
					return add + "select-select";
				}
				return add + this.r_name_sub_class;
			},
			err_msg:function(){
				return this.m_strErr;
			},
		},
		watch: {
			value:function(val){
				this.m_nSelect = this.checkMatchList();
				this.clearMsg();
			},
			r_list:function(list){
				this.createList();
				this.m_nSelect = this.checkMatchList();
				this.clearMsg();
			},
		},
		methods: {
			createCustomeId:function(prefix, suffix){
				var prefix = (prefix == undefined) ? '' : prefix;
				var suffix = (suffix == undefined) ? '' : suffix;
				// vueインスタンス固有のidを使用してidを生成
				var customeId = prefix + this._uid + suffix;
				return customeId;
			},
			createList:function(){
				this.m_arrList={};
				if(this.r_list){
					for(let key in this.r_list){
						if(this.r_list[key] != null){
							this.m_arrList[key]=this.r_list[key];
						}
					}
				}
			},
			validate:function(){
				 if( this.checkMatchList() == ""){// 一致するものがない
					this.m_strErr = this.msg_err.required;
					return false;
				}
				return true;
			},
			clearMsg:function(){
				this.m_strErr = true;
			},
			checkMatchList: function(){
				for ( var idx in this.m_arrList ) {
					if ( this.m_arrList[idx].value == this.value ) {
						return this.value;
					}
				}
				if ( this.value != "") {
					return this.r_not_match_list_text;
				} 
				return "";
			},
			/**
			 *  リスト選択時イベント <br>
			 * ******* 内部処理 *******<br>
			 * 選択されたリストの呼び出しコードをv-modelで宣言した変数に渡す。 <br>
			 * changeイベントを発行する。 <br>
			 *
			 * @instance
			 */
			onChange: function(value){
				var val = value;
				var list = this.m_arrList;
				var find = false;
				for(var key in list)
				{
					if( list[key].value == val ){
						find = true;
						break;
					}
				}
				if(find){
					//console.log("[ onChangeSelect ] value=" + val);

					var old  = this.value;
					this.$emit("input",val);
					this.$emit("event_change",val,old,this.r_id);
				}
				else{
					//console.log("[ No ChangeSelect ] value=" + val +" , " + this.value);
					//console.log(list);
				}

				this.resetScroll();
			},
			/**
			 *  リスト選択時イベント <br>
			 * ******* 内部処理 *******<br>
			 * 選択されたリストの呼び出しコードをv-modelで宣言した変数に渡す。 <br>
			 * changeイベントを発行する。 <br>
			 *
			 * @instance
			 */
			onChangeSelect: function(event){
				var val = event.target.value;
				var list = this.m_arrList;
				var find = false;
				for(var key in list)
				{
					if( list[key].value == val ){
						find = true;
						break;
					}
				}
				if(find){
					//console.log("[ onChangeSelect ] value=" + val);

					var old  = this.value;
					this.$emit("input",val);
					this.$emit("event_change",val,old,this.r_id);
				}
				else{
					//console.log("[ No ChangeSelect ] value=" + val +" , " + this.value);
					//console.log(list);
				}
			},
			setSelect: function(val){
				console.log("selectItem - setSelect : " + val);
				this.m_nSelect = val;
//				$("div." + this.main_class +" select." + this.sub_class).val(val);
			},
			createUUID : function(){
			    var S4 = function() {
			        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
			    };
			    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4() +S4());
			},
			onBlur: function(event){
				this.resetScroll();

				this.$emit("blur",event);
				if (this.validateEvent) {
					this.dispatch('ElFormItem', 'el.form.blur', [this.currentValue]);
				}
			},
			resetScroll: function(){
				// 内部テキストボックスのスクロール位置を初期化
				var customeId = this.createCustomeId(this.m_inputPrefix);
				var el = document.querySelector( '#' + customeId + ' .el-select .el-input__inner' );
				el.scrollLeft = 0;
				// 画面により適用されない場合があるので遅延実行
				setTimeout(function(){ el.scrollLeft = 0; }, 1000);
				setTimeout(function(){ el.scrollLeft = 0; }, 2000);
				setTimeout(function(){ el.scrollLeft = 0; }, 3000);
			},
		},
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/selectItem.vue